import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

export class Invoice {
  public static fetch(invoiceId: string): RequestConfigType {
    return RequestConfig.get(`/account/invoices/${invoiceId}`, { withLocalization: false });
  }
}
